import { defineStore } from "pinia";

export const useDatalayerStore = defineStore({
  id: 'datalayer',
  state: () => {
    return {
      subscribedFrom: "askAuthentification",
      authentificatedFrom: "askAuthentification",
      shippingMode: "",
      paymentMethod: "",
      location: "",
      storeLocatorContext: ""
    }
  },
  actions: {
    setAuthFrom(location) {
      this.authentificatedFrom = location
    },
    setSubscribedFrom(location) {
      this.subscribedFrom = location
    },
    setShippingMode(type) {
      this.shippingMode = type === "DRIVE" ? "DRV" : type
    },
    setPaymentMethod(pm) {
      this.paymentMethod = pm
    },
    setLocation(location) {
      this.location = location;
    },
    setStoreLocatorContext(location) {
      this.storeLocatorContext = location;
    }
  },
  getters: {
  }
})